import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

const pwWords = [
  "act",
  "bar",
  "car",
  "dew",
  "eat",
  "far",
  "gym",
  "hey",
  "ink",
  "jet",
  "key",
  "log",
  "mad",
  "bet",
  "nap",
  "odd",
  "pal",
  "ram",
  "saw",
  "tan",
  "turn",
  "vet",
  "wax",
  "yap",
  "zoo",
  "dog",
  "fix",
  "map",
  "rat",
  "cat",
  "bat",
  "ant",
  "pig",
  "cow",
  "ball",
  "play",
  "fast",
  "win",
  "hot",
  "cold",
  "cash",
  "swig",
  "best",
  "most",
  "pow",
  "top",
  "low",
  "streak",
  "box",
  "bird",
  "fish",
  "dogs",
  "snake",
  "lion",
  "tiger",
  "bear",
  "bunny",
  "red",
  "green",
  "black",
  "blue",
  "white",
  "goat",
  "sheep",
  "duck",
  "horse",
  "purple",
  "yellow",
  "brown",
  "indigo",
  "pasta",
  "pizza",
  "milk",
  "soda",
  "bread",
  "taco",
  "chip",
  "ham",
  "apple",
  "rice",
  "bean",
  "man",
  "boy",
  "foul",
  "money",
  "bags",
];
const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
});
class ClonePlayerCredentials extends Component {
  suggestPassword = () => {
    const item1 = pwWords[Math.floor(Math.random() * pwWords.length)];
    const item2 = 1 + Math.floor(Math.random() * 998);
    this.props.handleClonePropChange("password", `${item1}${item2}`);
  };
  checkAccountExistence = (accountID) => () => {
    this.props.checkAccountExistence(accountID);
  };
  handleAccountSuggestionID = (suggestion) => () => {
    this.props.handleClonePropChange("accountID", suggestion);
    this.props.checkAccountExistence(suggestion);
  };
  render() {
    const {
      classes,
      suggestData,
      clonePlayer,
      handlePropChange,
      swapEditAccountId,
    } = this.props;
    return (
      <React.Fragment>
        <Typography gutterBottom variant="headline" component="h2">
          Configure your new player account
        </Typography>
        <Typography component="p">
          Enter the full Account ID you wish to use:
        </Typography>
        <div>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <TextField
                disabled={clonePlayer.newAutoAccountMode}
                onChange={handlePropChange("accountID")}
                onBlur={this.checkAccountExistence(clonePlayer.accountID)}
                id="input-with-icon-grid"
                value={clonePlayer.accountID}
              />
              {clonePlayer.newAutoAccountMode && (
                <Button
                  color="primary"
                  onClick={swapEditAccountId}
                  className={classes.button}
                >
                  Edit
                </Button>
              )}
              {!clonePlayer.newAutoAccountMode && (
                <React.Fragment>
                  <div>
                    <Button
                      color="primary"
                      onClick={this.checkAccountExistence(
                        clonePlayer.accountID,
                      )}
                      className={classes.button}
                    >
                      Check
                    </Button>
                    <Button
                      color="primary"
                      onClick={swapEditAccountId}
                      className={classes.button}
                    >
                      Use Default
                    </Button>
                  </div>
                  <div>
                    {suggestData.account.length > 0 &&
                      suggestData.available === 1 && (
                        <span id="message-id">Accound ID is available</span>
                      )}
                  </div>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
          {suggestData.account.length > 0 && suggestData.available === 0 && (
            <Paper className={classes.root} elevation={4}>
              <Typography variant="headline" component="h3">
                That Account ID is already reserved by the system.
              </Typography>
              <Typography component="p">
                {suggestData.data.length === 0
                  ? "Please enter a different Account ID in the box above, or else press 'Use Default' to get an account automatically assigned."
                  : "Click one of these available options to use it instead, or else enter a different Account ID into the box above to try again."}
              </Typography>
              {suggestData.data.map((suggestion) => (
                <Button
                  key={`button-clone${suggestion}`}
                  variant="contained"
                  size="medium"
                  color="primary"
                  onClick={this.handleAccountSuggestionID(suggestion)}
                  className={classes.button}
                >
                  {suggestion}
                </Button>
              ))}
            </Paper>
          )}
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <TextField
                label="Password"
                placeholder="Password"
                onChange={handlePropChange("password")}
                value={clonePlayer.password}
              />
              <Button
                color="primary"
                onClick={this.suggestPassword}
                className={classes.button}
              >
                Suggest
              </Button>
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

ClonePlayerCredentials.propTypes = {
  theme: PropTypes.object.isRequired,
  prefix: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  suggestData: PropTypes.object.isRequired,
  clonePlayer: PropTypes.object.isRequired,
  handlePropChange: PropTypes.func.isRequired,
  swapEditAccountId: PropTypes.func.isRequired,
  handleClonePropChange: PropTypes.func.isRequired,
  checkAccountExistence: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "ClonePlayerCredentials",
    withTheme: true,
  }),
)(ClonePlayerCredentials);
